import { Color } from '@mui/material';
import * as colors from '@mui/material/colors';

const muiColors: { [index:string]:Color } = {
  amber: colors.amber,
  blue: colors.blue,
  blueGrey: colors.blueGrey,
  brown: colors.brown,
  cyan: colors.cyan,
  deepOrange: colors.deepOrange,
  deepPurple: colors.deepPurple,
  green: colors.green,
  grey: colors.grey,
  indigo: colors.indigo,
  lightBlue: colors.lightBlue,
  lightGreen: colors.lightGreen,
  lime: colors.lime,
  orange: colors.orange,
  pink: colors.pink,
  purple: colors.purple,
  red: colors.red,
  teal: colors.teal,
  yellow: colors.yellow,
};

export function getColor(name:string | null | undefined):Color {
  return name ? muiColors[name] : muiColors.grey;
}

export default muiColors;
